import { useState } from 'react';

export default function AppSection() {
  const [imgError, setImgError] = useState(false);

  return (
    <section id="app" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 via-primary-500 to-accent-500 rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12">
            <div className="flex-1 w-full text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
                随时随地 · 畅快观影
              </h2>
              <p className="text-sm md:text-base text-background-100/90 leading-relaxed mb-6">
                苹果视频完美适配手机、平板等移动设备，无需下载App，浏览器打开即可畅享全高清影视体验。支持西瓜视频免费、免费视频网站91等全部频道内容，走到哪看到哪。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
                {[
                  { icon: 'ri-smartphone-line', label: '手机观看' },
                  { icon: 'ri-tablet-line', label: '平板适配' },
                  { icon: 'ri-computer-line', label: '电脑端' },
                ].map((item) => (
                  <div key={item.label} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-50/20 text-background-50 text-sm">
                    <i className={item.icon}></i>
                    <span className="whitespace-nowrap">{item.label}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="w-full max-w-[280px] shrink-0">
              {!imgError ? (
                <div className="relative w-full aspect-[3/4] rounded-2xl overflow-hidden bg-background-50/15">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20mobile%20phone%20mockup%20showing%20video%20streaming%20interface%20with%20movie%20thumbnails%2C%20warm%20coral%20and%20amber%20color%20scheme%2C%20minimalist%20UI%20design%2C%20clean%20aesthetic%2C%20entertainment%20app%20concept&width=560&height=746&seq=app-01-2026&orientation=portrait"
                    alt="苹果视频移动端观影体验"
                    className="w-full h-full object-cover"
                    onError={() => setImgError(true)}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}